<template>
  <my-goods-page :initial-shop-type="1" :embedded="true" title="抖店管理 - 我的商品" />
</template>

<script>
import MyGoodsPage from '../myGoods/index.vue'

export default {
  name: 'NewMyGoodsDouyinPage',
  components: { MyGoodsPage }
}
</script>
